var _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnviewedNotif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 2.75,
    width: 10.7248,
    height: 10.7248,
    rx: 2.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.2246,
    cy: 4,
    r: 3,
    fill: "#FF0D3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnviewedNotif);
export default __webpack_public_path__ + "static/media/unviewed-notif.24021814d7c61d839d69af3557e5546e.svg";
export { ForwardRef as ReactComponent };